module.exports = __webpack_public_path__ + "assets/media/day4.3e1f7a87.mp3";